import React from 'react';
import { TextField, TextArea } from '@adobe/react-spectrum';
import PropTypes from 'prop-types';

import PageSectionDivider from '../../Layout/Content/PageSectionDivider';

const Input = ({ type, divider, ...props }) => {
  return (
    <>
      {type === 'text-field' && <TextField {...props} />}
      {type === 'text-area' && <TextArea {...props} />}
      {divider && <PageSectionDivider size="S" />}
    </>
  );
};

Input.propTypes = {
  divider: PropTypes.bool,
  type: PropTypes.string,
};

Input.defaultProps = {
  divider: false,
  type: 'text-field',
};

export default Input;
